import { SubjectExamGroup } from '@/plugins/api'
import alert from '@/plugins/alert'

/* eslint-disable no-unused-vars */
export default {
  namespaced: true,
  actions: {
    async fetchSubjectGroups({ commit }, options) {
      const subGroups = await SubjectExamGroup.fetch({ ...options })
      return subGroups
    },
    async fetchSubjectGroup({ commit }, id) {
      const subGroup = await SubjectExamGroup.fetchOne(id)
      return subGroup
    },
    async createSubjectGroup({ commit }, data) {
      const subGruop = await SubjectExamGroup.create(data)
      return subGruop
    },
    async updateSubjectGroup({ commit }, { id, ...data }) {
      const updatedGroup = await SubjectExamGroup.update(id, { ...data })
      return updatedGroup
    },
    async countSubjectGroups({ commit }, options) {
      try {
        return SubjectExamGroup.count(options)
      } catch (e) {
        alert.error(e)
      }
    }
  }
}
/* eslint-disable no-unused-vars */
